export enum VoidTransactionStatus {    
    Ok = 1,
    Void = 2
}
